/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  PostFormData,
  PostService,
  handleNumberChange,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";
import defaultImg from "../../../../assets/img/thumbnail.png";

export default function DigitalServices() {
  const priceoption = [
    {
      type: "gallery_wall",
      price: "",
    },
    {
      type: "story_canvas",
      price: "",
    },
    {
      type: "split_canvas",
      price: "",
    },
    {
      type: "single_panel",
      price: "",
    },
    {
      type: "plexi_print",
      price: "",
    },
    {
      type: "art_tray",
      price: "",
    },
    {
      type: "wood_print",
      price: "",
    },
    {
      type: "diamond_dust",
      price: "",
    }
  ];
  const [ServiceList, setServiceList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [Image, setImage] = useState("");
  const [ImgPath, setLocalImgPath] = useState("");
  const [description, setdescription] = useState("");
  const [submitLoader, setsubmitLoader] = useState(false);
  const [priceArray, setpriceArray] = useState(priceoption);
  const [name, setname] = useState("");
  const [isFree, setisFree] = useState(false);
  const [services, setservices] = useState("");

  useEffect(() => {
    getServiceList();
  }, [search_key, currentPage]);

  const getServiceList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_DIGITAL_SERVICE_LIST, param).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setServiceList(res?.data?.data?.item);
        SetTotalPageCount(res.data.data.totalPages);
        SetTotalCount(res.data.data.totalItems);
        setCount(res.data.data.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  const handlePriceChange = (index, newPrice) => {
    const updatedPriceArray = [...priceArray];
    updatedPriceArray[index].price = newPrice;
    setpriceArray(updatedPriceArray);
  };

  const onimageUpload = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setLocalImgPath(window.URL.createObjectURL(e.target.files[0]));
    }
  };

  const [selectedData, setSelectedData] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    setname(selectedData?.name);
    setdescription(selectedData?.description);
    setservices(selectedData?.services);
    setisFree(selectedData?.isFree==='true'?true:false); 
    setpriceArray(selectedData?.priceArray?.length>0? selectedData?.priceArray : priceoption);
    setImage(selectedData?.imageeffect);
    setLocalImgPath(selectedData?.imageeffect);
    console.log(isFree)
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();

    if (!name || !description || !ImgPath) {
      setError(true);
      return;
    }

    setsubmitLoader(true);


    const formdata = new FormData();
    if (selectedData?.id) {
      formdata.append("id", selectedData?.id);
    }
    formdata.append("name", name);
    formdata.append("description", description);
    formdata.append("services", services);
    formdata.append("isFree", isFree);
    formdata.append("priceArray", JSON.stringify(priceArray));
    formdata.append("service_image", Image);

    const route = selectedData?.id
      ? API_URL.UPDATE_DIGITAL_SERVICE
      : API_URL.ADD_DIGITAL_SERVICES;

    PostFormData(route, formdata).then(
      (res) => {
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getServiceList);
          resetFunc();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  function deleteService(S_id, name) {
    const data = {
      id: S_id,
      modelName: "additionaldigital_model",
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.PERMANENT_DELETE, data).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getServiceList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  function resetFunc() {
    setname("");
    setdescription("");
    setservices("");
    setisFree(false);
    setpriceArray(priceoption);
    setImage("");
    setLocalImgPath("");
    setError(false);
    setsubmitLoader(false);
    setSelectedData("")
  }

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Digital Services List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">
                  Digital Services List
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="align-items-center d-flex justify-content-end row">
                    <div className="col-md-8 p-0">
                      <div className="ml-4">
                        <button
                          className="btn btn-primary py-2"
                          data-toggle="modal"
                          data-target="#EditModal"
                          onClick={resetFunc}
                        >
                          Add Services
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4 p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Name"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div className="table-responsive mt-3">
                    {!loading && (
                      <table className="table table-hover text-nowrap table-striped table-bordered">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Image</th>
                            <th className="text-center">Name</th>
                            <th className="text-center">Description</th>
                            <th className="text-center">Service</th>
                            <th className="text-center">Price</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ServiceList?.map((data, i) => (
                            <tr key={i} className="text-center">
                              <td>{i + S_No_Count + 1}</td>
                              <td>
                                <img
                                  src={data?.imageeffect}
                                  alt=""
                                  onError={(e) => {
                                    e.target.src = defaultImg;
                                  }}
                                />
                              </td>
                              <td>{data?.name}</td>
                              <td
                                style={{
                                  whiteSpace: "break-spaces",
                                  lineHeight: "1.2",
                                }}
                              >
                                {data?.description}
                              </td>
                              <td>{data?.services}</td>
                              <td>
                                {data?.priceArray.length && data?.isFree==='false'? (
                                  <div>
                                    {data?.priceArray?.map((item, i) => (
                                      <div className="d-flex justify-content-between pr-4"><p className="text-capitalize font-weight-bold">{item?.type}</p><p>{item?.price}</p></div>
                                    ))}

                                  </div>
                                ) : 'No charge'}
                              </td>

                              <td className="text-center">
                                <span
                                  title="Update"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setSelectedData(data);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                                <span
                                      title="Delete"
                                      style={{ cursor: "pointer" }}
                                      className="mx-2"
                                      // data-toggle="modal"
                                      // data-target="#DeleteModal"
                                      onClick={() => {
                                        deleteService(data?.id, "Service");
                                      }}
                                    >
                                      <i className="text-danger fas fa-trash"></i>{" "}
                                    </span>
                              </td>
                            </tr>
                          ))}
                          {ServiceList && ServiceList.length === 0 && (
                            <tr>
                              <td colSpan="9" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                Digital Service
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 col-12">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      value={name}
                      className="form-control"
                      onChange={(e) => setname(e.target.value)}
                      placeholder="name"
                      disabled={selectedData?.name === 'Textured Canvas Coating'}
                    />
                    {error && !name && (
                      <div className="error">Name cannot be empty</div>
                    )}
                  </div>

                  <div className="col-md-6 col-12">
                    <label>Service</label>
                    <select
                      className="form-control"
                      value={services}
                      onChange={(e) => setservices(e?.target?.value)}
                    >
                      <option value={""}>select service</option>
                      <option value={"Effect"}>Effect</option>
                      <option value={"Retouching"}>Retouching</option>
                    </select>
                    {error && !services && (
                      <div className="error">service cannot be empty</div>
                    )}
                  </div>

                  <div className="col-12 mt-2">
                    <label>Description</label>
                    <textarea
                      type="text"
                      name="name"
                      value={description}
                      className="form-control"
                      onChange={(e) => setdescription(e.target.value)}
                      placeholder="Description"
                    ></textarea>

                    {error && !description && (
                      <div className="error">Description cannot be empty</div>
                    )}
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-12">
                    <div>
                      <label for="cbtest-19">Is this a Free service ? </label>

                      <div class="checkbox-wrapper-19">
                        <input
                          type="checkbox"
                          id="cbtest-19"
                          value={isFree}
                          onChange={(e) => { 
                            setisFree(e?.target?.checked);setpriceArray(priceoption);
                          }}
                          checked={isFree}
                        />
                        <label for="cbtest-19" class="check-box"></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  <label>Add Prices</label>
                  {!isFree ? (
                    <div className="row">
                      {console.log(priceArray)}
                      {priceArray.map((item, i) => (
                        <div className="col-lg-3 col-md-4 col-6 mt-2" key={i}>
                          <label className="text-capitalize">{item.type}</label>
                          <input
                            type="number"
                            name={item.type}
                            value={item.price}
                            className="form-control"
                            onChange={(e) => {
                              handlePriceChange(i, e.target.value)
                            }
                            }
                            placeholder="Enter price"
                          />
                          {error && !item.price && (
                            <div className="error">price cannot be empty</div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ fontSize: "larger" }}>
                      This Service is Free!
                    </div>
                  )}
                </div>

                <div className="mt-5">
                  <div className="row d-flex align-items-start">
                    <div className="col-lg-3 col-md-4 col-6">
                      <span>
                        <span className="btn btn-primary col-12">
                          Select Image
                          <input
                            type="file"
                            name="image"
                            accept=".jpg,.jpeg,.png"
                            className="btn-input position-absolute"
                            style={{ opacity: 0 }}
                            onChange={(e) => onimageUpload(e)}
                          />
                        </span>
                      </span>

                      {error && !Image && (
                        <div className="error mt-1">Image is required</div>
                      )}
                    </div>
                    <div className="col-lg-9 col-md-8 col-6">
                      <img
                        src={ImgPath ? ImgPath : ""}
                        alt="..."
                        className="CommonImage"
                        onError={(e) => {
                          e.target.src = defaultImg;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary py-2"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : selectedData?.id ? (
                    "Update"
                  ) : (
                    "Add"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
